import { render } from "./LogoFCC.vue?vue&type=template&id=1f54a950"
const script = {}

import exportComponent from "/home/mali/APP_FCCBookingApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__